export default __webpack_public_path__ + "static/media/jira-tool.06731db2.jfif";